import styled from "styled-components";


export const MyButton = styled.button`
  font-size: 1.2em;
   padding: 0.5em;
   margin: 0.5em;
   width: 12em;
   border: none;
   border-radius: 3px;
   color: white;
   background-color: ${props => props.inputColor};
   border: 0;
`;